import { stringLength } from './string-length.type';

export const validString = stringLength(1);
